import React, { FC, MouseEvent } from 'react'
import { StyledTNButton } from './TNButton.styled'

export interface TNButtonProps {
    btnType: 'primary' | 'muted' | 'danger'
    onClick: (e: MouseEvent<HTMLElement>) => void
    disabled?: boolean
}

export const TNButton: FC<TNButtonProps> = ({
    btnType,
    onClick,
    children,
    disabled,
}) => (
    <StyledTNButton onClick={onClick} btnType={btnType} disabled={disabled}>
        {children}
    </StyledTNButton>
)
